<ng-container *ngIf="formOptions && validForm">
    <form class="w-full p-4" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="w-full" *ngFor="let field of formOptions">
            <mat-form-field appearance="fill" class="w-full">
                <mat-label class="text-xl text-[#595959]">{{
                    field.name
                }}</mat-label>

                <ng-container *ngIf="field.type === FormType.Selector">
                    <mat-select
                        [formControlName]="field.slug"
                        [required]="selectRequired(field.validator)"
                    >
                        <mat-option value=""></mat-option>
                        <mat-option
                            *ngFor="let option of field.selectorOptions"
                            [value]="option.value"
                            >{{ option.appearance }}
                        </mat-option>
                    </mat-select>
                </ng-container>

                <ng-container *ngIf="field.type !== FormType.Selector">
                    <input
                        matInput
                        [type]="field.type"
                        [formControlName]="field.slug"
                        [placeholder]="field?.placeholder"
                        maxlength="75"
                    />
                </ng-container>

                <mat-hint
                    [id]="null"
                    *ngIf="form.get(field.slug)?.hasError('required')"
                    class="error-hint"
                >
                    This field is <strong>required</strong>
                </mat-hint>

                <mat-error *ngFor="let validator of field.validator">
                    <div *ngIf="form.get(field.slug)?.hasError(validator.slug)">
                        {{ validator.errorMessage || "Invalid input." }}
                    </div>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="flex justify-center content-center">
            <button
                [disabled]="submitButtonDisabled"
                class="w-[45%] bg-[#CBE0FF] text-[#2B5493] rounded-xl"
                mat-raised-button
                color="primary"
                type="submit"
            >
                {{ customButtonName || "Submit" }}
            </button>
        </div>
    </form>
</ng-container>
